import React, { useState, useEffect } from 'react'
import {
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import { onboarder } from '../../../api'
import Spinner from '../../Spinner/Spinner'

export default function ManagersCreate () {
  document.title = 'Create Manager | Superstruct Platform'

  const history = useHistory()
  const [manager, setManager] = useState({
    name: '',
    slackWorkspaceId: '',
    slackUserId: ''
  })
  const [thrownError, setThrownError] = useState(null)
  const [loaded, setLoaded] = useState(true)
  const [slackWorkspaces, setSlackWorkspaces] = useState([])
  const [errors, setErrors] = useState({
    name: '',
    slackWorkspaceId: '',
    slackUserId: ''
  })

  const validateForm = () => {
    const newErrors = {}
    if (!manager.name) {
      newErrors.name = 'Manager name is required'
    }
    if (!manager.slackUserId) {
      newErrors.slackUserId = 'Slack User ID is required'
    }
    if (!manager.slackWorkspaceId) {
      newErrors.slackWorkspaceId = 'Slack Workspace is required'
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  useEffect(() => {
    if (slackWorkspaces?.length) setLoaded(true)
  }, [slackWorkspaces])

  useEffect(() => {
    onboarder.listSlackWorkspaces((error, response) => {
      if (error) return setThrownError(error)
      setSlackWorkspaces(response)
    })
  }, [])

  if (thrownError) {
    return (
      <Grid>
        <Grid>{`ERROR: ${thrownError}`}</Grid>
      </Grid>
    )
  }

  if (!loaded) {
    return <Spinner />
  }
  const handleCreate = () => {
    if (!validateForm()) {
      return
    }
    setLoaded(false)
    onboarder.createManager(manager, (error, response) => {
      if (error) {
        setThrownError(error)
        setLoaded(true)
        return
      }
      setLoaded(true)
      history.push(`/onboarder/managers/${response.id}`)
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setManager((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <Grid>
      <>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                required
                error={!!errors.name}
                helperText={errors.name}
                label='Name'
                name='name'
                value={manager.name}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                error={!!errors.slackUserId}
                helperText={errors.slackUserId}
                label='Slack User ID'
                name='slackUserId'
                value={manager.slackUserId}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <InputLabel>Slack Workspace</InputLabel>
                <Select
                  required
                  error={!!errors.slackWorkspaceId}
                  value={manager.slackWorkspaceId}
                  name='slackWorkspaceId'
                  onChange={handleChange}
                  style={{ minWidth: '200px' }}
                >
                  {slackWorkspaces.map((workspace) => (
                    <MenuItem key={workspace.id} value={workspace.id}>
                      {workspace.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleCreate}
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </form>
      </>
    </Grid>
  )
}
